import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

interface FileUploadModalProps {
  open: boolean;
  handleClose: () => void;
  handleUpload: (file: File) => void;
  leadType: string; // Add this new prop
}

const FileUploadModal: React.FC<FileUploadModalProps> = ({
  open,
  handleClose,
  handleUpload,
  leadType,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setSelectedFile(event.target.files[0]);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
       <DialogTitle>
        Upload {leadType === "fertility" ? "Fertility" : "General"} Lead File
      </DialogTitle>
      <DialogContent>
        <input type="file" onChange={handleFileChange} accept=".xlsx, .csv" />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          sx={{
            backgroundColor: "red",
            color: "white !important",
            "&:hover": { backgroundColor: "darkred" },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => selectedFile && handleUpload(selectedFile)}
          disabled={!selectedFile}
          sx={{
            backgroundColor: "green",
            color: "white !important",
            "&:hover": { backgroundColor: "lightgreen" },
          }}
        >
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FileUploadModal;
